import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-stains',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './stains.component.html',
    styleUrls: ['./stains.component.scss'],
    standalone: false
})
export class StainsComponent {
  readonly FlatModels = FlatModels;

  constructor(public constantAuthorFacade: FlatFacades.ConstantAuthorFacade,
              public navigationControlFacade: FlatFacades.NavigationControlFacade) {
  }

  rowTrackBy(index: number,
             item: FlatModels.StainEntityModels.Stain) {
    return item.id || index;
  }

  onRowSelect($event: any) {
    this.navigationControlFacade.requestNavigate(['stain', $event.data]);
  }

  addNewStain() {
    this.navigationControlFacade.requestNavigate(['stain']);
  }
}
